<template>
	<div class="r-d-form">
		<div class="box-card">
			<img src="../assets/cg.png" style="width: 124px;margin-top: 118px;" />
			<p style="font-size: 28px;color: #333333;">提交成功</p>
			<p style="font-weight: 400;font-size: 20px;color: #666666;">服务人员马上与您联系为您报价</p>
			
			<img :src="qrcode ? $url+qrcode : '../assets/ma.png'" style="width: 124px;margin-top: 80px;" />
			<div style="font-weight: 400;font-size: 16px;color: #666666;">扫描二维码</div>
			<div style="font-weight: 400;font-size: 16px;color: #666666;">关注昱栎技术公众号</div> 
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				qrcode: '',
			};
		},
		mounted() {
			this.loadConfig();
		},
		methods: {
			// 服务详情
			loadConfig() {
				this.$http.get('/index/config?key=gzh_qrcode').then(res => {
					this.qrcode = res.data.text
					console.log(this.qrcode)
				}).catch(err => {
					console.error('请求失败', err);
				});
			},
		}
	};
</script>
<style scoped>
	.r-d-form {
		height: 100vh;
		background-color: #FAFAFA;
	}

	.box-card {
		width: 950px;
		margin: 0 auto;
		text-align: center;
	}
</style>